import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiAiDesign {
  /**
   * Fetch the active AI Design system prompt.
   *
   * @returns {Promise<{id: number, system_prompt: string}>}
   */
  static getDesignPrompt() {
    return apiFetch(`${ApiBaseUrl}ai_design_prompt`);
  }

  /**
   * Update the active AI Design system prompt.
   *
   * @param {string} systemPrompt - The new system prompt text.
   * @returns {Promise<{id: number, system_prompt: string}>}
   */
  static updateDesignPrompt(systemPrompt) {
    return apiFetch(`${ApiBaseUrl}ai_design_prompt`, {
      method: "PUT",
      body: { ai_design_prompt: { system_prompt: systemPrompt } },
    });
  }
}
